<template>
  <div class="about" v-if="data">
    <!-- <div class="container">
      <div class="row">
        <div v-for="c in data.content" v-bind:key="c.value" class="column">
          <div v-html="c.value"></div>
        </div>
      </div>
    </div> -->
    <!-- <div class="container full-width map-link">
        <div class="row">
            <div class="column">
            <div class="map-link-wrap">
                <a class="map-link-circle">
                <i class="fas fa-map-marked-alt fa-3x"></i>
                </a>
                <h4>Visit the map page for directions and more.</h4>
            </div>
            </div>
        </div>
    </div> -->
    <!-- Map Link -->
    <div class="header-spacer"></div>
    <MapBar/>
    <!-- End Map Link -->
    <div id="grouped-items" class="container">
        <h2 v-if="data.results.length == 0">{{ data.message }}</h2>
        <transition-group name="list-complete" class="row row-wrap" tag="div">
            <div v-for="gp in data.results" v-bind:key='gp.id' class="column column-33 subpage-item has-background-initial">
                <div class="subpage-inner rounded-border">
                    <div v-if="$router.resolve({ name: gp.id+'-slide' }).resolved.matched.length > 0">
                        <router-link :to="{ name: gp.id + '-slide' }" tag="a" class="has-color-pink pagination-image" v-if="gp.thumbnail">
                            <img v-if="gp.thumbnail" class="subpage-image" :data-url="gp.thumbnail.url" v-lazyload>
                        </router-link>
                        
                        <router-link :to="{ name: gp.id + '-slide' }" tag="a" class="has-color-pink">
                            <h3>{{ gp.title }}</h3>
                        </router-link>
                    </div>
                    <div v-else>
                        <router-link :to="{ name: gp.id }" tag="a" class="has-color-pink pagination-image" v-if="gp.thumbnail">
                            <img v-if="gp.thumbnail" class="subpage-image" :data-url="gp.thumbnail.url" v-lazyload>
                        </router-link>
                        
                        <router-link :to="{ name: gp.id }" tag="a" class="has-color-pink">
                            <h3>{{ gp.title }}</h3>
                        </router-link>
                    </div> 
                    <p class="has-bold-text">{{ gp.address }}</p>
                    <p>{{ gp.phone_number }}</p>
                    <p>{{ gp.starting_at }}</p>
                    <p>{{ gp.relative_price }}</p>

                    <p v-if="gp.website"><a v-bind:href="gp.website" target="_blank">Website</a></p>
                    <p v-for='link in gp.other_links' v-bind:key="link.id"><a v-bind:href="link.url" target="_blank">{{ link.link_text }}</a></p>
                    <p>{{ gp.event_date_display }}</p>
                </div>
            </div>
        </transition-group>
      </div>
  </div>
</template>

<script>
import LazyLoad from '@/utils/LazyLoad'
import MapBar from '@/components/MapBar.vue'
import axios from 'axios'
export default{
  name: 'SearchIndexPage',
  directives: {
    lazyload: LazyLoad
  },
  data(){
    return{
      data: null,
    }
  },
  components: {
    MapBar,
  },
  props: {
      searchQuery: {
          type: String
      }
  },
  watch: {
      searchQuery: function() {
            this.fetchData().then(data =>{
                this.data = data
            })
      }
  },
  created (){
    this.fetchData().then(data =>{
      this.data = data
    })
  },
  methods:{
    fetchData(){
       var id = this.$route.meta.id
       return axios.get('/api/search/?query='+this.searchQuery).then(response => {
        //  console.log(JSON.stringify(response))
         return response.data;
       })
    },
  }

}
</script>

<style scoped>
  .header-spacer{
    height: 75px;
  }

  .map-link{
    padding: 2rem 0 0 0;
    text-align: center;
    color: #fff;
    background: #1dd974;
    height: 7rem;
  }

  .map-link .column{
    /* display: flex; */
    /* justify-content: center; */
  }

  .map-link h4{
    display: inline-block;
    margin-left: 3rem;
  }

  .map-link-wrap{
    position: relative;
    display: inline-block;
    padding-left: 80px;
  }

  .map-link i{
       margin-top: -8px;
  }

  .map-link-circle {
    position: absolute;
    left: 0;
    top: -27px;
    z-index: 5;
    border-radius: 50%;
    background: #009e49;
    padding: 22px 17px;
    cursor: pointer;
    color: #fff;
    transition: all .25s;
  }

   .map-link-circle:hover{
     color: #c0f2d7;
   }

  .hero{
    position: relative;
    z-index: 2;
    background: #fff
  }

  .hero .row{
    min-height: 550px;
    flex-direction: row;
  }

  h1{
      /* text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%; */
  }

  p{
    margin-top: 0;
    font-weight: 500;
    font-size: 16px;
  }

  .has-background-quaternary{
    background: #0594dc;
  }
 
  .vert-center{
    width: 85%;
  }

  .column{
    position: relative;
  }

  .index-cta, .hero{
    min-height: 550px;
    background-size: cover;
  }

  .column img{
    display: block;
  }

  .subpage-top {
    /* border-top-left-radius: 1.5rem; */
    /* border-top-right-radius: 1.5rem; */
    border: 1rem;
    overflow: hidden;
    background: #333;
    /* padding: 2rem 2rem 1rem 2rem; */
  }

  .subpage-top img{
    /* border-top-left-radius: 1.5rem; */
    /* border-top-right-radius: 1.5rem; */
  }

  .subpage-item p{
    margin-bottom: .5rem;
  }

  .subpage-item h3{
    margin-top: .5rem;
  }

  .subpage-item{
    margin-bottom: 3rem;
    /* height: 420px;
    min-height: 420px; */
    /* background: #333; */
  }

  .subpage-inner{
    /* border: .35rem solid #333;
    border-radius: 1.5rem; */
    /* border-bottom-right-radius: 1.5rem; */
    padding: 2rem;
    /* height: 100%; */
    /* min-height: 260px; */
    /* color: #fff; */
    /* background: #333; */
  }

  #grouped-items{
    padding-top: 4rem;
    
  }

  #grouped-items .row{
    min-height: 50vh;
  }

  .index-cta{
    padding: 8rem 35% 8rem 4rem;
    padding: 8rem 4rem;
  }

  .heading-wrap{
    /* text-align: center; */
    margin-bottom: 1rem;
  }

  .heading-wrap h1{
    display: inline-block;
    /* border: 3px solid; */
    /* border-radius: 1rem; */
    margin-bottom: 0;
    padding: 1rem;
  }
  .index-image{
    background-size: cover;
    background-position: 50%
  }


  .cell-item {
    transition: transform 1s;
  }

  .cool-gradiant {
    background: linear-gradient(28deg, #E5E559, #E5E55C 50%, transparent 25%) transparent;
  }

  .hero .row{
    background-size: cover;
    background-position: 50%;
  }

  .cta-inner{
    /* border: 2px solid #fff; */
    border-radius: 9px;
    padding: 2rem;
    /* box-shadow: 0 16px 40px rgba(0,0,0,0.12) !important; */
  }
  
  .slide-enter-active, .slide-leave-active{
    transition: all .5s;
  }

  .slide-enter, .slide-leave-to{
    transform: translateX(-150%);
    opacity: .5;
  }

  .subpage-item{
    transition: all .5s;
    /* display: inline-block; */
  }

  .subpage-image{
    opacity: 0;
    transition: opacity .5s;
  }

  .subpage-image.loaded{
    opacity: 1;
  }

  /* .list-complete-item {
  transition: all 5s;
  display: inline-block;
  margin-right: 10px;
} */

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-bottom: 16px solid #3498db;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>